import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const progressRingCss = ":host{position:relative;box-sizing:border-box}:host *,:host *:before,:host *:after{box-sizing:inherit}:host{--size:1.5rem;--track-width:0.125rem;--track-color:var(--tt-color-gray-100);--indicator-color:var(--tt-color-green-400);display:inline-flex}.progress-ring{display:inline-flex;align-items:center;justify-content:center;position:relative;width:var(--size);height:var(--size)}.progress-ring__image{aspect-ratio:1;transform:rotate(-90deg);transform-origin:50% 50%;font-size:calc((var(--size) - var(--track-width)) / 2)}.progress-ring__track{stroke:var(--track-color);stroke-width:var(--track-width);stroke-linecap:square;fill:transparent}.progress-ring__indicator{stroke:var(--indicator-color);stroke-width:var(--track-width);transition:0.35s stroke-dashoffset, 0.35s stroke;stroke-linecap:square;fill:transparent}.progress-ring__label{display:flex;align-items:center;justify-content:center;position:absolute;top:0;left:0;width:100%;height:100%;text-align:center;user-select:none}";

const ProgressRing = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.percentage = undefined;
  }
  handlePercentageChange() {
    this.updateProgress();
  }
  connectedCallback() {
    this.updateProgress = this.updateProgress.bind(this);
  }
  componentDidLoad() {
    window.requestAnimationFrame(this.updateProgress);
  }
  updateProgress() {
    var _a, _b, _c;
    const radius = (_c = (_b = (_a = this.indicator.r) === null || _a === void 0 ? void 0 : _a.baseVal) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : 1;
    const circumference = radius * 2 * Math.PI;
    const offset = circumference - (this.percentage / 100) * circumference;
    this.indicator.style.strokeDasharray = `${circumference} ${circumference}`;
    this.indicator.style.strokeDashoffset = `${offset}`;
  }
  render() {
    return (h("div", { part: "base", class: "progress-ring" }, h("svg", { class: "progress-ring__image" }, h("circle", { class: "progress-ring__track", r: "1em", cx: "50%", cy: "50%" }), h("circle", { ref: (el) => (this.indicator = el), class: "progress-ring__indicator", r: "1em", cx: "50%", cy: "50%" })), h("span", { part: "label", class: "progress-ring__label" }, h("slot", null))));
  }
  static get watchers() { return {
    "percentage": ["handlePercentageChange"]
  }; }
  static get style() { return progressRingCss; }
}, [1, "tt-progress-ring", {
    "percentage": [2]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-progress-ring"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-progress-ring":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ProgressRing);
      }
      break;
  } });
}

const TtProgressRing = ProgressRing;
const defineCustomElement = defineCustomElement$1;

export { TtProgressRing, defineCustomElement };
